import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IService } from '../../../models/index';
import { IUpdateServiceState } from '../../actions/types/services/UpdateServiceTypes';

/**
 * Initial Service state in store
 */
const initialState: IUpdateServiceState = {
  isLoading: false,
  errorMessage: '',
  success: false,
  serviceData: {} as IService
};

/**
 * Create Service Slice to update new Service
 */
const updateServiceSlice = createSlice({
  name: 'updateService',
  initialState,
  reducers: {
    updateServiceStarted: (state) => {
      state.isLoading = true;
    },

    updateServiceSuccess: (
      state,
      action: PayloadAction<IService>
    ) => {
      state.isLoading = false;
      state.serviceData = action.payload;
      state.success = true;
      state.errorMessage = '';
    },

    updateServiceFail: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.serviceData = initialState.serviceData;
      state.success = false;
      state.errorMessage = action.payload;
    },

    clearUpdateServiceDetails: (state) => {
      state.isLoading = false;
      state.serviceData = initialState.serviceData;
      state.errorMessage = '';
      state.success = false;
    }
  }
});

export const {
  updateServiceStarted,
  updateServiceSuccess,
  updateServiceFail,
  clearUpdateServiceDetails
} = updateServiceSlice.actions;
export default updateServiceSlice.reducer;
